



































































import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import vueSvgDraw from "vue-svg-draw";
import { MetaInfo } from "vue-meta";

@Component<Home>({
  components: {
    vueSvgDraw,
  },
  metaInfo(): MetaInfo {
    return{
      // if no subcomponents specify a metaInfo.title, this title will be used
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      title: "SWISS ECO BAGS ™ | " + (this as any).$i18n.t("concept.advantages"),
      meta: [
        {
          vmid: "description",
          name: "description",
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          content: (this as any).$i18n.t("advantages.description"),
        },
      ],
    }
  },
})
export default class Home extends Vue {
  public labels = [
    {
      image: require("../assets/recycle.svg"),
      titleKey: "home.labels.1",
    },
    {
      image: require("../assets/homemade.svg"),
      titleKey: "home.labels.homemade",
    },
    {
      image: require("../assets/ogm.svg"),
      titleKey: "home.labels.2",
    },
    {
      image: require("../assets/yourlogo.svg"),
      titleKey: "home.label.custom",
    },
    {
      image: require("../assets/swiss.svg"),
      titleKey: "home.labels.swiss",
    },
    {
      image: require("../assets/protected-factory.svg"),
      titleKey: "home.labels.4",
    },
    {
      image: require("../assets/compostable.svg"),
      titleKey: "home.labels.compostable",
    },
    {
      image: require("../assets/second-life.svg"),
      titleKey: "home.labels.second-life",
    },
  ];
}
